import { useState } from 'react';
import Ayuda from '../ui/Ayuda';
import { guardarArchivo } from '../ui/descarga';
import { ofreceZpl, RESOLUCIONES_ZPL } from './hojasDeEtiquetas';

// EL ARCHIVO PARA IMPRESORA DE ROLLO (ZPL) · U-02 fase d (DISEÑO §6.1).
//
// Lo pinta el modal de `paginas/Etiquetas.jsx` debajo de «Bajar el PDF»,
// y SOLO con una hoja de rollo elegida: con carta o A4 este componente no
// pinta nada (no se muestra un control que no sirve).
//
// SIN PROBAR EN UNA IMPRESORA REAL. El servidor genera el ZPL y la suite
// lo valida con un validador escrito en el árbol, que es el lado que ya
// funciona; ninguna Zebra lo ha impreso todavía (AC-6 abierta). Por eso
// la etiqueta gris «Sin probar en impresora» y la ayuda del botón lo dicen
// con esas palabras, pegadas a la decisión de bajarlo.
//
// LA ETIQUETA DE PRUEBA (auditoría U-02d, H8). Antes del archivo completo
// la pantalla ofrece «Bajar una etiqueta de prueba»: el mismo archivo con
// UNA sola etiqueta, la del primer producto de la lista, y una copia. El
// modal no se cierra, para que después se pueda bajar el completo. Su
// ayuda dice exactamente eso y nada más.
//
// 320 px: las dos resoluciones a lo ancho con su objetivo de 44 px, y los
// botones a ancho completo, como el del PDF.
export default function BajarZpl({ formato, ids, onListo }) {
  const [dpi, setDpi] = useState(RESOLUCIONES_ZPL[0]);
  const [bajando, setBajando] = useState(null);
  const [error, setError] = useState(null);
  const [pruebaLista, setPruebaLista] = useState(false);

  if (!ofreceZpl(formato)) return null;

  async function bajar(deprueba) {
    setBajando(deprueba ? 'prueba' : 'todo');
    setError(null);
    setPruebaLista(false);
    const cuerpo = deprueba
      ? { ids: ids.slice(0, 1), formato: formato.codigo, dpi, copias: 1 }
      : { ids, formato: formato.codigo, dpi };
    try {
      const r = await fetch('/api/qr/etiquetas.zpl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(cuerpo),
      });
      if (!r.ok) {
        const respuesta = await r.json().catch(() => ({}));
        throw new Error(respuesta.detalle || 'No se pudo armar el archivo para la impresora de rollo. Vuelve a intentarlo.');
      }
      if (deprueba) {
        guardarArchivo(await r.blob(), 'etiqueta-de-prueba.zpl');
        setPruebaLista(true);
      } else {
        guardarArchivo(await r.blob(), 'etiquetas.zpl');
        if (onListo) onListo();
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setBajando(null);
    }
  }

  return (
    <div data-zpl className="space-y-2 rounded-lg border border-gray-200 p-3 min-w-0">
      <div className="flex flex-wrap items-center gap-2">
        <strong className="text-sm text-gray-900">Archivo para impresora de rollo (ZPL)</strong>
        <span data-sin-probar
              className="inline-block rounded bg-gray-100 px-1.5 py-0.5 text-[11px] font-semibold text-gray-700">
          Sin probar en impresora
        </span>
      </div>

      <fieldset className="space-y-1 min-w-0">
        <legend className="text-sm text-gray-900">Resolución de la impresora</legend>
        <div className="flex flex-wrap gap-2">
          {RESOLUCIONES_ZPL.map((v) => (
            <label key={v}
                   className={`flex min-h-11 flex-1 items-center gap-2 rounded-lg border px-3 cursor-pointer ${
                     dpi === v ? 'border-[var(--color-marca)] bg-blue-50' : 'border-gray-200'}`}>
              <input type="radio" name="dpi-zpl" value={v} checked={dpi === v}
                     className="h-5 w-5 shrink-0" onChange={() => setDpi(v)} />
              <span className="text-sm">{v} puntos por pulgada</span>
            </label>
          ))}
        </div>
        <Ayuda id="etiquetas.zpl.resolucion" />
      </fieldset>

      {error && (
        <div role="alert" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded p-2.5">
          {error}
        </div>
      )}

      <button type="button" data-zpl-prueba onClick={() => bajar(true)} disabled={bajando !== null}
              className="w-full min-h-11 border border-gray-300 text-gray-900 disabled:opacity-60 font-semibold py-2.5 rounded-lg text-sm">
        {bajando === 'prueba' ? 'Armando la etiqueta…' : 'Bajar una etiqueta de prueba'}
      </button>
      <Ayuda id="etiquetas.zpl.prueba" />
      {pruebaLista && (
        <p role="status" className="text-sm text-green-800 bg-green-50 border border-green-200 rounded p-2.5">
          Listo: se guardó etiqueta-de-prueba.zpl, con una sola etiqueta. Mándala a la impresora y revísala antes de bajar el archivo completo.
        </p>
      )}

      <button type="button" onClick={() => bajar(false)} disabled={bajando !== null}
              className="w-full min-h-11 border border-[var(--color-marca)] text-[var(--color-marca)] disabled:opacity-60 font-semibold py-2.5 rounded-lg text-sm">
        {bajando === 'todo' ? 'Armando el archivo…' : 'Bajar el archivo ZPL'}
      </button>
      <Ayuda id="etiquetas.zpl.boton" />
    </div>
  );
}
